import React from 'react';
import { Container } from 'react-bootstrap';
import { Redirect, Route, Switch } from 'react-router-dom';
import { IProps } from './type';
import Suspense from '../../shared/components/suspense';
import ErrorBoundaryWrapper from '../../shared/components/error-boundary-wrapper';
import retryLazy from '../retry-lazy';

import AiSeqGeneratorModal from './components/ai-seq-generator-modal';
import SequenceListFallback from './components/fallbacks/sequence-list-fallback';
import SingleSequenceFallback from './components/fallbacks/single-sequence-fallback';

const SequenceList = React.lazy(() =>
  retryLazy(
    () =>
      import(
        /* webpackChunkName: "sequence-list" */ './components/sequence-list'
      ),
  ),
);

const SequenceSingle = React.lazy(() =>
  retryLazy(
    () =>
      import(
        /* webpackChunkName: "sequence-single" */ './components/sequence-single/'
      ),
  ),
);

const Sequence: React.FC<IProps> = () => (
  <Container fluid className="sequence-container p-0">
    <ErrorBoundaryWrapper>
      <Switch>
        <Route exact path="/sequence">
          <Suspense fallback={<SequenceListFallback />}>
            <SequenceList />
          </Suspense>
        </Route>
        <Route path="/sequence/:sequenceId/prospects/:prospectId/:tab">
          <Suspense fallback={<SingleSequenceFallback />}>
            <SequenceSingle />
          </Suspense>
        </Route>
        <Route path="/sequence/:sequenceId/emails/:prospectId/:tab">
          <Suspense fallback={<SingleSequenceFallback />}>
            <SequenceSingle />
          </Suspense>
        </Route>
        <Route path="/sequence/:sequenceId/:activeTab/:subsequenceId/:subsequenceActiveTab">
          <Suspense fallback={<SingleSequenceFallback />}>
            <SequenceSingle />
          </Suspense>
        </Route>
        <Route path="/sequence/:sequenceId/:activeTab">
          <Suspense fallback={<SingleSequenceFallback />}>
            <SequenceSingle />
          </Suspense>
        </Route>
        <Redirect to="/sequence" />
      </Switch>
    </ErrorBoundaryWrapper>
    <AiSeqGeneratorModal />
  </Container>
);

export default Sequence;
